import { ENTITLEMENT } from '../../constants';
import type { CalculateEntitlementType } from '../../../types/calculate-entitlement-type';
import { isTruthyCustomParamValue } from '../../utils/common';

export const isGenericEntitlementType: CalculateEntitlementType = (config) => {
  const host = typeof config.custom?.entitlementHost === 'string' ? config.custom.entitlementHost : undefined;
  const urlSigning = isTruthyCustomParamValue(config.custom?.urlSigning);

  return host && urlSigning ? ENTITLEMENT.GENERIC : null;
};

export const isAWSCognitoEntitlementType: CalculateEntitlementType = (config) => {
  const hasStripeProductIds = !!config.custom?.stripeProductIds;
  const urlSigning = isTruthyCustomParamValue(config.custom?.urlSigning);

  return hasStripeProductIds && urlSigning ? 'COGNITO_STRIPE' : null;
};
